/* eslint-disable @typescript-eslint/naming-convention */
import 'reflect-metadata';
import {FormElement, FormElementConfiguration} from 'app/entities/form/formElement.entity';
import {FormElementSegmentView, FormElementType} from 'app/entities/enums';
import {Type} from 'class-transformer';
import {Dictionary} from 'app/entities/dictionary.entity';
import {SwitchRadioCollection} from 'app/entities/switchCollection.entity';

export class FormElementSegment extends FormElement {
  type: FormElementType = 'segments';

  @Type(() => FormElementSegmentConfiguration)
  configuration?: FormElementSegmentConfiguration = new FormElementSegmentConfiguration();
}

export class FormElementSegmentConfiguration extends FormElementConfiguration {
  dictionaryCode?: string = null;
  view?: FormElementSegmentView = 'secondary';

  @Type(() => Dictionary)
  dictionaryList?: Dictionary[] = [];

  getListCollection?() {
    return new SwitchRadioCollection(this.dictionaryList.map((item) => item.getSwitchItem()));
  }
}
